import React from 'react';

const DescripcionLambrin = () => {
  return (
    <section>
      <div className="container">
        {/* Título y resumen */}
        <div className="row align-items-end mb-2-9 mb-lg-10">
          <div className="col-lg-6 col-xl-6 col-xxl-7 mb-1-6 mb-lg-0">
            <div className="w-xxl-70">
              <span className="text-secondary text-uppercase small letter-spacing-4 d-block mb-2 font-weight-700">
              Resistencia y sostenibilidad juntas
              </span>
              <h2 className="mb-0 display-5 font-weight-700">
              Características Clave del {' '}
                <strong className="fst-italic">Lambrín Sintético</strong>
              </h2>
            </div>
          </div>
        </div>

        {/* Características */}
        <div className="row mt-n1-9">
          {[
            {
              imgSrc: '/assets/img/icons/icon-flecha-derecha-redonda.png',
              title: 'Resistencia al Agua y Humedad',
              description:
                'Ideal para baños, cocinas y exteriores. Su composición sintética evita problemas como deformaciones o deterioro.',
              delay: '200ms',
            },
            {
              imgSrc: '/assets/img/icons/icon-flecha-derecha-redonda.png',
              title: 'Durabilidad Extrema',
              description:
                'Fabricado con materiales de alta calidad, el lambrín sintético mantiene su apariencia impecable incluso en condiciones exigentes.',
              delay: '300ms',
            },
            {
              imgSrc: '/assets/img/icons/icon-flecha-derecha-redonda.png',
              title: 'Fácil Instalación',
              description:
                'Su diseño ligero y práctico permite una instalación rápida y eficiente, ahorrando tiempo y costos en obra.',
              delay: '400ms',
            },
            {
              imgSrc: '/assets/img/icons/icon-flecha-derecha-redonda.png',
              title: 'Mínimo Mantenimiento',
              description:
                'Su superficie no porosa evita la acumulación de suciedad y facilita la limpieza, ideal para espacios que requieren higiene constante.',
              delay: '500ms',
            },
          ].map((feature, index) => (
            <div
              className="col-sm-6 col-lg-3 mt-1-9 wow fadeInUp"
              data-wow-delay={feature.delay}
              key={index}
            >
              <div className="pe-md-3 hover-effect">
                <img
                  src={feature.imgSrc}
                  alt="..."
                  className="w-60px mb-1-9"
                />
                <h4 className="mb-4 h5">{feature.title}</h4>
                <p className="mb-0 display-30">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DescripcionLambrin;
